import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { PostsProvider as Provider, platformProviderValue } from '@shapeable/ui';

const POSTS_QUERY = graphql`
query PlatformAllPostsQuery {
  platform { allPosts { 
    id name name_fr name_de path slug __typename
    typeLabel
    taxonomyLabel
    intro { plain text }
    intro_fr { text }
    intro_de { text }
    content { text }
    content_fr { text }
    content_de { text }
    title
    title_fr
    title_de
    color { id name value }
    openGraph { description { plain } image { thumbnails { card { url url2x } } } }
    type { id name slug __typename }
    published
    topics {
      openGraph { image { url } }
      _schema { label pluralLabel }
      __typename id name slug
    }
    challenges {
      openGraph { image { url } }
      _schema { label pluralLabel }
      __typename id name slug
    }
    authors {
      __typename
      openGraph { image { url } }
      id name slug path
      organisation { id name }
      linkedin
      photo { id url url2x thumbnails { bubble { url url2x } } }
    }
    organisationAuthors {
      id name slug path __typename
      openGraph { image { id thumbnails { bubble { url url2x } } } }
      logo { id url url2x }
    }
  } }
}
`;

export const PostsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(POSTS_QUERY), 'allPosts' ) }>{children}</Provider>;
};